import React from 'react'

import {
  PillAdminVariant,
  PillOwnerVariant,
  PillFinanceVariant,
} from '@sketch/components'
import { StyledPill } from './MemberBadge.styles'

export type BadgeType =
  | 'super-admin'
  | 'admin'
  | 'owner'
  | 'pending-invite'
  | 'finance'
  | 'partner'

export const BADGE_PROPS_BY_TYPE = {
  'super-admin': {
    color: 'orange',
    children: 'Super Admin',
  },
  owner: {
    color: 'teal',
    children: 'owner',
    variant: PillOwnerVariant,
  },
  admin: {
    color: 'indigo',
    children: 'admin',
    variant: PillAdminVariant,
  },
  'pending-invite': {
    color: 'orange',
    children: 'Pending',
    variant: { kind: 'secondary' },
  },
  finance: {
    color: 'indigo',
    children: 'finance',
    variant: PillFinanceVariant,
  },
  partner: {
    color: 'indigo',
    children: 'partner',
  },
} as const

interface MemberBadgeProps {
  badge: BadgeType
}

const MemberBadge: React.FC<MemberBadgeProps> = ({ badge }) => {
  return <StyledPill {...BADGE_PROPS_BY_TYPE[badge]} />
}

export default MemberBadge
